module.exports = __webpack_public_path__ + "img/perW.5a070c9a.png";